export enum CargoReportEventTypeEnum {
    NORTender = 4,
    CertificateOfCleanliness = 34, // Tank inspection result
    EmptyTankCertificate = 55, // Tanks accepted empty
    DeadfreightClaim = 94,
    ProtestDiff = 95,
    SlowRate = 96,
    InsufficientNumberOfHoses = 98,
    GeneralProtest = 106,
    ReTenderNOR = 177,
    UseOfVesselHoses = 191,
    FreePratique = 190,
}
